export default __webpack_public_path__ + "static/media/heavyrain.2874d3af.svg";